import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';

import { html } from 'lit';
import { PageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';

import { DeploymentsView } from '../../supplier/deployments-view';

@customElement('app-deployments')
export class AppDeployments extends PageBase {
  @state()
  private deploymentsView: DeploymentsView | null = null;

  constructor() {
    super();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.deploymentsView);
    this.deploymentsView = null;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container ls-deployments">${this.deploymentsView?.ui}</div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`SoftTech Dealer License Server - Deployments`,
      description: tlang`Supplier Tenant Settings Page`
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.deploymentsView) return await this.deploymentsView.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    //we need to flush the user data store any time we come to this page in case it is stale information
    this.deploymentsView = await constructAsync(new DeploymentsView());
  }
}
